import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const RootProviders = lazy(() => import('@app/components/AppProviders'))
const FilesToolToggle = lazy(() => import('.'))

declare global {
  interface HTMLElementTagNameMap {
    'files-tool-toggle': FilesToolToggleComponent
  }
}

class FilesToolToggleComponent extends ReactWebComponent {
  static get observedAttributes() {
    return ['active']
  }

  override render() {
    return (
      <RootProviders>
        <FilesToolToggle isActive={this.prop('active') === 'true'} />
      </RootProviders>
    )
  }
}

customElements.define('files-tool-toggle', FilesToolToggleComponent)
